<template>
    <div class="notice">
        <header class="main-title">
            <p>{{ nTitle }}</p>
        </header>
        <section>
            <!--考生须知-->
            <div class="exam-rules-page page" :style="dialogVisible == 1 ? 'display: block;' : 'display: none;'">
                <div class="ct">
                    <div class="content">
                        <div class="WordSection1" style="layout-grid:16.3pt">

                            <p class="MsoNormal" align="center" style="margin-left:18.0pt;text-align:center;
layout-grid-mode:char"><b><span lang="EN-US" style="font-size:18.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif">2025</span></b><b><span style="font-size:18.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif">年全国导游资格考试</span></b></p>

                            <p class="MsoNormal" align="center" style="margin-left:18.0pt;text-align:center;
layout-grid-mode:char"><b><span style="font-size:18.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">考生须知</span></b></p>

                            <p class="MsoNormal" align="center" style="margin-left:18.0pt;text-align:center;
layout-grid-mode:char"><b><span lang="EN-US" style="font-size:16.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif">&nbsp;</span></b></p>

                            <p class="MsoNormal" style="text-indent:22.0pt"><span
                                    style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">请考生认真阅读本须知，并执行考试主办方关于考试的有关规定。同时，请考生及时关注报考所在地考试组织部门在全国导游资格考试网上报名系统上发布的考试相关要求，依法依规履行考生责任和义务，确保考试安全、顺利举行。</span></p>

                            <p class="1" style="text-indent:0cm"><b><span style="font-size:11.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif">一、考生入场要求（包括但不限于）</span></b></p>

                            <p class="11" style="text-indent:22.0pt"><span lang="EN-US" style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">1</span><span style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">、开考前<span lang="EN-US">30</span>分钟，考生须凭本人纸质准考证和有效期内的身份证件原件进入考场，</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">有效期内的身份证件必须和报名时所提交的有效证件一致。经监考人员核对无误后，</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">须考生先在《考场情况记录表》上签字确认，考生如隐瞒或提供虚假材料（信息）的，立即取消考试资格。造成不良后果的，将依法追究考生法律责任；再</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">对考生逐一进行现场拍照，完成身份校验。</span>
                            </p>

                            <p class="11" style="text-indent:22.0pt"><span
                                    style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">有效身份证件包括：居民身份证、香港身份证、澳门身份证、中华人民共和国台湾居民居住证、台湾居民来往大陆通行证（台胞证）、中华人民共和国港澳居民居住证、港澳地区居民来往内地通行证。</span></p>

                            <p class="MsoNormal" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">2</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">考生须按监考人员指定座位号入座，将纸质准考证和身份证件放置在桌面上，以备检查。</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">考生入座后，输入准考证号登录考试系统，</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">登录后请考生仔细核对个人信息及本人照片，</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">仔细阅读《考生须知》，并按系统提示进行确认，</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">等待考试开始。考生如发现信息有误，应举手向监考人员示意，并听从监考人员的安排进行现场登记处理。</span>
                            </p>

                            <p class="1" style="text-indent:0cm"><b><span style="font-size:11.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif">二、考试科目及时间</span></b></p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif">第一部分：科目一“政策与法律法规”、科目二“导游业务”</span></p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif;color:#424242">科目一、二合并为<span lang="EN-US">1</span>张试卷进行测试，</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">考试时间：<span
                                        lang="EN-US">2024</span>年<span lang="EN-US">11</span>月<span
                                        lang="EN-US">23</span>日<span lang="EN-US">09:00</span>—<span
                                        lang="EN-US">10:30</span>，考试时长<span lang="EN-US">90</span>分钟。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">第二部分：科目三“全国导游基础知识”、科目四“地方导游基础知识” </span></p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif;color:#424242">科目三、四合并为<span lang="EN-US">1</span>张试卷进行测试，</span><span style="font-size:11.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif">考</span><span style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">试时间：<span
                                        lang="EN-US">2024</span>年<span lang="EN-US">11</span>月<span
                                        lang="EN-US">23</span>日<span lang="EN-US">10:30</span>—<span
                                        lang="EN-US">12:00</span>，考试时长<span lang="EN-US">90</span>分钟。</span></p>

                            <p class="1" align="left" style="text-align:left;text-indent:22.0pt"><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">两部分考试连续进行，中途考生不得离开考试座位。第一部分结束后，考试系统将自动进入第二部分，考生答题进入第二部分之后将无法返回第一部分答题。考试时间满<span
                                        lang="EN-US">180</span>分钟时，系统将会自动提交试卷，考试结束。</span></p>

                            <p class="1" style="text-indent:0cm"><b><span style="font-size:11.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif">三、答卷方式</span></b></p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">考试以闭卷形式进行，所有试题均通过计算机完成答题，试题全部为客观题。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">第一部分：试卷总分<span lang="EN-US">100</span>分，共<span
                                        lang="EN-US">165</span>题。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">判断题<span lang="EN-US">40</span>题，每题<span lang="EN-US">0.5</span>分，共<span
                                        lang="EN-US">20</span>分；单项选择题<span lang="EN-US">90</span>题，每题<span
                                        lang="EN-US">0.5</span>分，共<span lang="EN-US">45</span>分；多项选择题<span
                                        lang="EN-US">35</span>题，每题<span lang="EN-US">1</span>分，共<span
                                        lang="EN-US">35</span>分</span><span style="font-size:
11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">第二部分：试卷总分<span lang="EN-US">100</span>分，共<span
                                        lang="EN-US">165</span>题。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">判断题<span lang="EN-US">40</span>题，每题<span lang="EN-US">0.5</span>分，共<span
                                        lang="EN-US">20</span>分；单项选择题<span lang="EN-US">90</span>题，每题<span
                                        lang="EN-US">0.5</span>分，共<span lang="EN-US">45</span>分；多项选择题<span
                                        lang="EN-US">35</span>题，每题<span lang="EN-US">1</span>分，共<span
                                        lang="EN-US">35</span>分</span><span style="font-size:
11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">。</span></p>

                            <p class="1"><b><span
                                        style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">四、注意事项</span></b>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">1</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、试题均为客观题。</span>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">2</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、考生可选择“标记本题”按钮进行标记，方便考生根据标记及时回到标记试题进行试题检查。</span>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">3</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、一旦进入第二部分<span
                                        lang="EN-US">，</span>考生将无法返回查看、修改第一部分的答案。</span></p>

                            <p class="1"><b><span
                                        style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">五、考场纪律</span></b>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">1</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、考生应自觉遵守考场秩序，尊重考试工作人员，自觉接受监考人员的监督和检查，保持考场安静，遇到问题应举手向监考人员示意，禁止在考场内吸烟或吃东西</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">2</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">考试期间，考生须配合监考人员要求。</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">考生若出现发热、咳嗽、咽痛、胸痛、腹痛、呼吸困难、腹泻、呕吐等异常状况，应立即向监考人员举手示意。如果因突发疾病不能继续考试的，应当停止考试，立即就医。</span>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">3</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、迟到超过<span
                                        lang="EN-US">15</span>分钟的考生不得入场，迟到未超过<span
                                        lang="EN-US">15</span>分钟的考生可以进入考场，但需在开考<span
                                        lang="EN-US">15</span>分钟内在考试机上登录并确认，未能在开考<span
                                        lang="EN-US">15</span>分钟内登录并确认的考生视为缺考，考试系统将不再接受该准考证号登录，迟到的时长计入考试时间。<span
                                        lang="EN-US">11:30</span>前，考生不得提前交卷离场。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">4</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、考生进入考场时，除携带纸质准考证、有效期内的身份证件原件之外，禁止携带书籍、演算笔、资料、笔记本、草稿纸、电子工具、手机、食物、饮料等与考试无关的物品。已携带入场的，应按监考人员要求存放至指定位置（携带的通讯工具、电子设备等应全部关闭后，再存放至指定位置）。考生未按要求存放或违规携带物品的，将按《全国导游人员资格考试管理办法（试行）》有关规定做出处理。</span>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">5</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、如考试计算机出现运行故障等异常情况，考生应举手示意，请监考人员帮助解决，不得自行处置。在异常情况处置期间，考生应在座位上安静等待，听从监考人员和考试工作人员的安排与引导。</span>
                            </p>

                            <p class="1" align="left" style="text-align:left;text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">6</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、<span style="color:
black">整个考试期间，考生不得中途离开考试座位。因特殊原因暂时离开考试座位的须经监考人员同意并由工作人员陪同，考试计时在考生离开的过程中不中断。已完成考试的考生应尽快有序离开考场，不得在考场附近逗留。</span></span>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">7</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、考试结束后考生应按监考人员要求退场。提前结束考试退场者不得在考场附近逗留、喧哗</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">8</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、<span style="color:
black">考试将对考场进行全程录像监管，</span>考试结束后，工作人员将对现场监控进行查阅，<span
                                        style="color:black">如发现未当场处理的作弊行为</span>，作弊考生的成绩将被取消，并按相关违纪条例处理。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">9</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、考生因未按要求操作造成的一切后果由考生本人承担。</span>
                            </p>

                            <p class="1"><b><span
                                        style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">六、违纪情况处理规定</span></b>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span style="font-size:11.0pt;
font-family:&quot;微软雅黑&quot;,sans-serif">考生在考试期间违纪、违规的，按照《全国导游人员资格考试管理办法（试行）》第二十一条、第二十二条进行处理。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">第二十一条
                                    参加考试人员有以下情形之一，经监考老师提醒后不改正的，该科考试成绩按零分处理，并在一年内不得报名参加资格考试：</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">一<span
                                        lang="EN-US">)</span>在考试期间旁窥、交头接耳或者互打手势的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">二<span
                                        lang="EN-US">)</span>在考场或者其他禁止的范围内，喧哗、吸烟或者实施其他影响考场秩序的行为的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">三<span
                                        lang="EN-US">)</span>未按规定携带手机、信号接听器等电子通讯、存储、摄录设备的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">四<span
                                        lang="EN-US">)</span>将草稿纸等考试用纸带离考场的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">五<span
                                        lang="EN-US">)</span>未经考场工作人员同意在考试中擅自离开考场的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">六<span
                                        lang="EN-US">)</span>帮助他人作答，纵容他人抄袭的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">七<span
                                        lang="EN-US">)</span>抄袭与考试内容相关材料的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">八<span
                                        lang="EN-US">)</span>其他一般违纪违规行为</span><span style="font-size:11.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif;color:black">。</span></p>

                            <p class="1" style="text-indent:22.0pt"><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">第二十二条
                                    参加考试人员有以下情形之一的，该科考试成绩按零分处理，并在两年内不得报名参加资格考试，导游从业人员存在以下违纪违规行为的，文化和旅游部将相关信息记入导游从业人员信息管理系统；并可注销该从业人员的资格证书，三年内不受理其报名申请</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">。</span>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">一<span
                                        lang="EN-US">)</span>教唆或组织团伙作弊的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">二<span
                                        lang="EN-US">)</span>由他人冒名代替参加考试或者冒名代替他人参加考试的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">三<span
                                        lang="EN-US">)</span>使用摄录设备获取考试内容的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">四<span
                                        lang="EN-US">)</span>使用手机、手表、等电子通讯、储存设备接听、接收、查看考试信息的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">五<span
                                        lang="EN-US">)</span>使用或提供伪造、涂改身份证件的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">六<span
                                        lang="EN-US">)</span>蓄意报复考试工作人员的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">七<span
                                        lang="EN-US">)</span>恶意操作导致考试无法正常运行的；</span></p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">(</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif;color:black">八<span
                                        lang="EN-US">)</span>其他严重违纪违规行为</span><span style="font-size:11.0pt;font-family:
&quot;微软雅黑&quot;,sans-serif;color:black">。</span></p>

                            <p class="1"><b><span
                                        style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">七、其他</span></b>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">1</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、考生须妥善保管好纸质准考证及电子打印件，以备考试和领取资格证时使用。考试当天考生如未携带纸质准考证，将不能进入考场。</span>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">2</span><span
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">、因考站管理要求，考站不提供停车位，请考生尽量乘坐公共交通前往。</span>
                            </p>

                            <p class="1" style="text-indent:22.0pt"><span lang="EN-US"
                                    style="font-size:11.0pt;font-family:&quot;微软雅黑&quot;,sans-serif">&nbsp;</span></p>

                        </div>
                    </div>
                </div>
                <div class="btn-group">
                    <div class="pop-sure" style="text-align: center;">
                        <el-checkbox v-model="checked" :true-label="1" :false-label="0">我已阅读</el-checkbox>
                    </div>
                    <div class="btn-list">
                        <!--<div class="prev-step btn default-btn btn">上一步</div>-->
                        <div @click="nextTick"
                            :class="checked == 0 ? 'next-step btn default-btn btn disabled-btn' : 'next-step btn default-btn btn'"
                            id="exam-rules_next_btn">下一步</div>
                    </div>
                </div>
            </div>
            <!--操作指南-->
            <div class="instructions-page page" :style="dialogVisible == 2 ? 'display: block;' : 'display: none;'">
                <div class="operation-intro">
                    <div class="ct">
                        <div class="info">
                            <div :class="isAuto == false ? 'intro-area list-show' : 'intro-area list-hide'">
                                <div class="lt" id="intro_area">
                                    <div class="top-info-area">
                                        <p>本说明详细介绍了机考系统的使用方法、答题方式，以及考生需要了解的重要事项。</p>
                                        <p>在开始考试之前，请仔细阅读。</p>
                                    </div>
                                    <div class="page page-h-tag">
                                        <h3 class="title">重要事项</h3>
                                        <div class="list-item">
                                            <ul>
                                                <!-- <li>
                                                <div class="list-item-info">
                                                    <p><span class="span-blue">•</span></p>
                                                    <p>所有考生在<span class="strong">草稿纸</span>上书写的所有答题结果<span class="strong">一律无效</span>；<span class="strong">草稿纸</span>在考试结束后<span class="strong">一律不得</span>带出考场。</p>
                                                </div>
                                            </li> -->
                                                <li>
                                                    <div class="list-item-info">
                                                        <p><span class="span-blue">•</span></p>
                                                        <p>在试题内容较多的情况下，请务必用鼠标拖动屏幕的<span
                                                                class="strong">滚动条</span>，以避免遗漏重要信息。</p>
                                                    </div>
                                                </li>
                                                <!-- <li>
                                                <div class="list-item-info">
                                                    <p><span class="span-blue">•</span></p>
                                                    <p>主观题的<span class="strong">资料区</span>以及<span class="strong">作答区</span>的工具栏使用方法可以参考<span class="strong">答题辅助功能使用说明</span>。此外，为方便考生作答，答题时使用键盘直接输入数字或符号，以及使用快捷键功能，系统都可接受，作答结果不受影响。</p>
                                                </div>
                                            </li> -->
                                                <li>
                                                    <div class="list-item-info">
                                                        <p><span class="span-blue">•</span></p>
                                                        <p>在考试过程中，如果遇到任何您认为与机考系统软件、设备硬件故障相关的问题，请立即举手向监考人员示意，并在等待解决的过程中保持安静以免影响其他考生。
                                                        </p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="page page-h-tag">
                                        <h3 class="title">机考系统布局介绍</h3>
                                        <div class="imgIntro-item page-item">
                                            <p>机考系统布局分为三个区域，主要分为<span class="strong">标题区、试题列表区、答题区</span>，如下图所示。</p>
                                            <img class="page-img big-img"
                                                src="https://demo.joytest.org/seat/skin/demo:97034044a7/images/intro/objective/01_01.jpg">
                                            <p><span class="strong">标题区</span>，如下图所示。</p>
                                            <div class="page-item-ct">
                                                <img class="page-img big-img"
                                                    src="https://demo.joytest.org/seat/skin/demo:97034044a7/images/intro/objective/01_02.jpg">
                                                <div class="img-intro-list">
                                                    <ul>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div><span
                                                                    class="strong">字号调节：</span>考生可以调节答题界面文字大小，字号有小、中、大三种，默认字号为中。
                                                            </div>
                                                        </li>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div><span
                                                                    class="strong">作答进度：</span>考生可以查看当前单元内已答试题的题量和总题量。
                                                            </div>
                                                        </li>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div><span
                                                                    class="strong">剩余时间：</span>显示当前单元考试剩余答题时间。考生应合理分配答题时间。一旦当前单元时间结束，无需考生进行确认，机考系统会自动禁止考生继续答题，并自动执行<span
                                                                    class="strong">进入下一单元</span>操作，当前单元为最后一个单元时自动执行<span
                                                                    class="strong">交卷</span>操作，自动提交个人答题结果。</div>
                                                        </li>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div><span class="strong">座位号：</span>机考系统为每台考试机预先设定的<span
                                                                    class="strong">编号</span>。</div>
                                                        </li>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div><span
                                                                    class="strong">暂离锁屏：</span>如果考生在征得监考人员同意的情况下需要暂时离开考位，为保护个人答题界面的安全，可以点击<span
                                                                    class="strong">暂离锁屏</span>按钮，对答题界面进行屏幕保护。如下图所示。
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <!-- <p>如果考生使用了<span class="strong">暂离锁屏</span>功能，答题界面将处于<span class="strong">屏幕保护</span>状态，</p> -->
                                                <img class="page-img big-img"
                                                    src="https://demo.joytest.org/seat/skin/demo:97034044a7/images/intro/objective/08_01.jpg">
                                                <p>如果考生的答题界面处于<span class="strong">暂离锁屏</span>状态时，请考生注意<span
                                                        class="strong">暂离锁屏界</span>面上的剩余时间，此时考试机同样<span
                                                        class="strong">计时</span>，一旦整场考试结束，无需考生进行<span
                                                        class="strong">解除暂离锁屏</span>确认，机考系统会自动禁止<span
                                                        class="strong">暂离锁屏</span>的考生继续答题，并自动执行<span
                                                        class="strong">交卷</span>操作，自动提交个人答题结果。</p>
                                                <p>如果考生在<span class="strong">暂离锁屏</span>期间，需要返回考试，考生在<span
                                                        class="strong">“请输入准考证号”</span>编辑框中输入准考证号，然后点击<span
                                                        class="strong">继续考试</span>按钮。</p>
                                                <p>&nbsp;</p>
                                            </div>
                                            <p><span class="strong">试题列表区</span>，如下图所示。</p>
                                            <div class="page-item-ct">
                                                <img class="page-img big-img"
                                                    src="https://demo.joytest.org/seat/skin/demo:97034044a7/images/intro/objective/01_03.jpg">
                                                <div class="img-intro-list">
                                                    <ul>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div>
                                                                <span
                                                                    class="strong">考生信息：</span>此处显示考生入场时拍摄的照片及个人信息。在考试过程中，如考场监考人员、巡考人员需要核对个人信息，请考生予以配合。
                                                            </div>
                                                        </li>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div><span
                                                                    class="strong">试题列表显示/隐藏：</span>考生可以通过试题列表显示/隐藏功能，将左侧的试题列表面板隐藏，将答题界面最大化显示；试题列表也可由考生自行恢复显示。
                                                            </div>
                                                        </li>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div>
                                                                <p><span class="strong">试题列表</span>中，以<span
                                                                        class="strong">数字</span>代表题号。考生可以查看试卷结构和题量，以及每道试题的作答状态。
                                                                </p>
                                                                <p>试题的状态用不同的<span
                                                                        class="strong">图标</span>样式进行区分，包括当前试题、未完成试题、已完成试题。
                                                                </p>
                                                                <p>如考生需要快速的跳转到某道试题，考生可以通过点击<span
                                                                        class="strong">试题列表</span>上对应的<span
                                                                        class="strong">数字</span>标签，系统会直接进入到该试题，方便考生进行答题或检查试题。
                                                                </p>
                                                                <p>当<span class="strong">试题</span>较多时，考生可以用鼠标上下拖动<span
                                                                        class="strong">纵向滚动条</span>以查看全部试题列表，以免遗漏。</p>
                                                            </div>
                                                        </li>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div><span class="strong">交卷：</span>在整场考试时限未到之前，如果考生决定要<span
                                                                    class="strong">提前交卷</span>，可以通过点击<span
                                                                    class="strong">交卷</span>按钮结束答题。</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <p><span class="strong">答题区</span></p>
                                            <div class="page-item-ct">
                                                <div class="img-intro-list">
                                                    <ul>
                                                        <li class="item">
                                                            <div>• </div>
                                                            <div>考生需根据答题区内呈现的试题内容，在此区域内操作并作答。</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="page page-h-tag">
                                        <h3 class="title">答题界面介绍</h3>
                                        <!-- <p class="title-intro">答题界面按试题类型分为<span class="strong">录像题</span>和<span class="strong">客观题</span>两种题型，以下分别进行介绍。</p> -->
                                        <div class="page-item objective-item-intro">
                                            <div class="page-item-title">客观题</div>
                                            <div class="page-item-ct">
                                                <p><span class="strong">客观题</span>答题界面如下图所示。</p>
                                                <img class="page-img big-img"
                                                    src="https://demo.joytest.org/seat/skin/demo:97034044a7/images/intro/objective/09_01.jpg">
                                                <p><span class="strong">客观题</span>答题界面按上下结构分为<span
                                                        class="strong">试题区</span>和<span class="strong">工具栏区</span></p>
                                                <p><span class="strong">试题区：</span>显示试题题干和备选项等，当内容较多时，考生可以用鼠标上下拖动<span
                                                        class="strong">右侧</span>的<span
                                                        class="strong">纵向滚动条</span>阅读全部内容，以免遗漏。</p>
                                                <div class="page-item-ct-list">
                                                    <p><span class="strong">客观题</span>包括<span
                                                            class="strong">单选题</span>、<span
                                                            class="strong">多选题</span>和<span class="strong">判断题</span>。
                                                    </p>
                                                    <p><span class="strong">单选题、判断题</span>答题时，考生直接用鼠标点击备选项中认为正确的<span
                                                            class="strong">一个</span>选项。如果需要撤销已经选中的选项，再次点击该选项、或者用鼠标点击其他备选项即可；机考系统只允许考生在所有备选项中选择<span
                                                            class="strong">一个</span>备选项作为答案。</p>
                                                    <p><span class="strong">多选题</span>答题时，考生直接用鼠标点击备选项中认为正确的<span
                                                            class="strong">所有</span>选项。如果需要撤销已经选中的选项，再次点击该选项即可；机考系统允许考生在所有备选项中选择<span
                                                            class="strong">任意多个</span>备选项作为答案。</p>
                                                </div>
                                                <p><span class="strong">工具栏区：</span>如下图所示。</p>
                                                <img class="page-img big-img"
                                                    src="https://demo.joytest.org/seat/skin/demo:97034044a7/images/intro/objective/09_02.jpg">
                                                <div class="page-item-ct-list">
                                                    <p><span class="strong">标记本题：</span>如果需要提醒自己稍后返回检查当前试题，则可以点击<span
                                                            class="strong">标记本题</span>按钮，再次点击<span
                                                            class="strong">取消标记</span>按钮则取消标记。被标记的试题会在左侧的试题列表中突出显示。对试题所作的标记，不会被作为答题结果，也不会影响考生得分情况。合理使用试题标记功能，可以帮助考生在大量的试题中快速查找到需要重点检查的试题。
                                                    </p>
                                                    <p><span class="strong">上一题：</span>可以通过点击<span
                                                            class="strong">上一题</span>按钮，按顺序进入<span
                                                            class="strong">上一个</span>答题页面。</p>
                                                    <p><span class="strong">下一题：</span>可以通过点击<span
                                                            class="strong">下一题</span>按钮，按顺序进入<span
                                                            class="strong">下一个</span>答题页面。</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="page page-h-tag">
                                        <h3 class="title">结束考试</h3>
                                        <div class="page-item">
                                            <div class="page-item-title">考生提前交卷</div>
                                            <div class="page-item-ct">
                                                <p>在整场考试时限未到之前 ，如果考生决定要<span class="strong">提前交卷</span>，在<span
                                                        class="strong">试题列表</span>下方点击<span
                                                        class="strong">交卷</span>按钮结束答题。</p>
                                                <p>此时，机考系统会提醒考生对交卷的决定进行<span class="strong">二次</span>确认。在<span
                                                        class="strong">任意一次</span>确认时如选择<span
                                                        class="strong">取消</span>，系统将终止交卷可继续考试；如果考生连续<span
                                                        class="strong">二次</span>确认交卷，系统将结束考试<span
                                                        class="strong">不能</span>继续答题。</p>
                                                <p>考生在<span class="strong">提前交卷</span>之前，务必仔细检查自己的<span
                                                        class="strong">答题情况</span>。</p>
                                                <p>考生在个人考试机上进行<span class="strong">提前交卷</span>，<span
                                                        class="strong">不会</span>中断其他考生的考试过程。因此在交卷后，务必尽快整理好个人物品并安静地离开考场，以免影响其他考生继续答题。
                                                </p>
                                            </div>
                                        </div>
                                        <div class="page-item">
                                            <div class="page-item-title">整场考试结束</div>
                                            <div class="page-item-ct">
                                                <p>一旦整场考试时间结束，机考系统会自动禁止<span class="strong">所有</span>考生继续答题，并进行<span
                                                        class="strong">统一交卷</span>，此时<span
                                                        class="strong">无需</span>考生进行任何操作。</p>
                                                <p>注意：在正常考试结束、系统自动收卷时，如有考生处于<span
                                                        class="strong">暂离锁屏</span>状态，机考系统也会自动为其进行交卷操作。考生返回后，<span
                                                        class="strong">不能</span>再次登录机考系统。</p>
                                                <p>考试结束后，机考系统会<span class="strong">自动</span>收集并上传所有考生的<span
                                                        class="strong">答题结果</span>。</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="rt">
                                    <div class="intro-lt-btn" @click="isAuto = !isAuto"></div>
                                    <div class="intro-list">
                                        <div class="list-line">
                                            <div class="line-point top-point"></div>
                                            <div class="line-point bottom-point"></div>
                                        </div>
                                        <ul id="menu">
                                            <li>
                                                <div class="tag select-tag"></div>
                                                <div class="text" attr_index="0">
                                                    <p>重要事项</p>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="tag point-tag"></div>
                                                <div class="text" attr_index="1">
                                                    <p>机考系统布局介绍</p>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="tag point-tag"></div>
                                                <div class="text" attr_index="2">
                                                    <p>答题界面介绍</p>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="tag point-tag"></div>
                                                <div class="text" attr_index="3">
                                                    <p>结束考试</p>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btn-list">
                            <div class="tip"
                                style="color:red;margin: 0 auto ; display: block;position:absolute;top: 10px;"></div>
                            <div @click="prevTick"
                                class="operation-intro-btn operation-intro-cancel skin_btn btnGray prev-step btn default-btn btn">
                                上一步</div>

                            <div v-if="nums != 0" class="next-step btn default-btn btn disabled-btn">
                                下一步({{ nums }})</div>

                            <div v-else @click="threeTick"
                                class="operation-intro-btn operation-intro-continue skin_btn btnBlue next-step btn default-btn btn">
                                下一步</div>
                        </div>
                    </div>
                </div>
            </div>

            <!--等待开考-->
            <div class="wait-start-exam-page page" :style="dialogVisible == 3 ? 'display: block;' : 'display: none;'">
                <div class="wait-ct ct wait-exam" style="display: none;">
                    <div class="logo">
                        <img src="/public/images/guide/wait_exam.png">
                    </div>
                    <div class="title">正式考试尚未开始</div>
                    <div class="intro">
                        <p>正式考试尚未开始，请耐心等待</p>
                        <p>到达统一开考时间后，系统会自动进入考试并开始计时</p>
                    </div>
                </div>
                <div class="wait-ct ct start-exam" style="display: flex;">
                    <!--<p>请等待开考</p>-->
                    <div class="logo">
                        <img src="../../../public/images/guide/start_exam.png">
                    </div>
                    <div class="title">正式考试已经开始</div>
                    <div class="intro">
                        <p>请点击下面按钮进入考试</p>
                    </div>
                </div>
                <div class="btn-group">
                    <div class="btn-list">
                        <div @click="dialogVisible = 2" class="btn btn-primary confirm prev-btn prev-step">上一步</div>
                        <div @click="goQuestion" class="hide btn btn-primary confirm step-btn next-step"
                            id="start_exam">开始考试</div>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
export default {
    data() {
        return {
            nums: 5,
            dialogVisible: 1,
            checked: 0,
            isAuto: false,
            nTitle: "考生须知",
            mecoId: sessionStorage.getItem("access-mecoId"),
            column_id: sessionStorage.getItem("access-column_id"),
            paper_id: 0,
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.paper_id) {
            that.paper_id = query.paper_id;
        }
        sessionStorage.removeItem("access-mecoPapers");
        this.getList();
    },
    methods: {
        countTime() {
            if (this.nums <= 10 && this.nums > 0) {
                this.nums = this.nums - 1;
                setTimeout(this.countTime, 1000);
            } else {
                this.nums = 0;
            }
        },

        getList() {
            let that = this;
            let formData = {};
            formData.column_id = that.column_id;
            formData.subject_id = that.mecoId;
            formData.paper_id = that.paper_id;
            that.axios.post("/getPaperMeco", formData).then((res) => {
                console.log(res.data);
                if (res) {
                    that.pc = res.data.pc;
                    that.pc_id = res.data.pc_id;
                    sessionStorage.setItem("access-mecoPapers", JSON.stringify(res.data));
                }
            });
        },

        nextTick() {
            if (this.checked == 0) {
                return false;
            } else {
                this.nTitle = "操作指南";
                this.dialogVisible = 2;
                setTimeout(this.countTime, 1000);
            }
        },

        prevTick() {
            this.nTitle = "考生须知";
            this.checked = 0;
            this.dialogVisible = 1;
        },

        threeTick() {
            this.dialogVisible = 3;
        },

        goNotice() {
            this.$router.push({
                path: "/guide/notice",
                query: {
                    paper_id: this.paper_id,
                },
            });
            //this.$router.push("/guide/notice");
        },

        goQuestion() {
            this.$router.push({
                path: "/guide/question",
                query: {
                    paper_id: this.paper_id,
                },
            });
            //this.$router.push("/guide/question");
        },
    },
};
</script>

<style>
.notice ::-webkit-scrollbar {
    width: 11px;
    height: 11px;
    position: relative;
    left: 10px;
}

.notice ::-webkit-scrollbar-thumb {
    background-color: #606d71;
    background-clip: padding-box;
    min-height: 28px;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
}

.notice {
    width: 100%;
    height: 100vh;
    background: url(../../../public/images/guide/bg_common.png) center bottom/100% auto no-repeat #eef3ff;
}

.notice .main-title {
    width: 100%;
    height: 75px;
    line-height: 90px;
}

.notice .main-title p {
    font-size: 36px;
    text-align: center;
}

.notice section {
    background: #fff;
    width: 97%;
    height: calc(95% - 60px);
    margin-top: 30px;
    min-height: 610px;
    min-width: 1000px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    box-shadow: 0 0 20px 0 rgba(171, 178, 219, 0.5);
    transition: all 0.3s;
}

.notice section>.page {
    display: none;
    width: 100%;
    height: 100%;
}

.notice .covid-19-confirm-page,
.notice .exam-rules-page,
.notice .wait-start-exam-page {
    position: relative;
}

.notice .covid-19-confirm-page .ct,
.notice .exam-rules-page .ct,
.notice .wait-start-exam-page .ct {
    padding: 30px;
    border-radius: 6px;
    box-shadow: inset 2px 2px 11px -1px #abb2db, inset -2px -2px 11px -1px #abb2db;
    overflow-y: scroll;
    border: 1px solid #ccc;
    position: absolute;
    top: 30px;
    left: 30px;
    right: 30px;
    bottom: 80px;
    margin: 0 1.5rem 1.5rem 1.5rem;
}

.notice .exam-rules-page .ct *,
.notice .covid-19-confirm-page .ct * {
    all: revert;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .list-item ul li {
    margin-bottom: 2rem;
}

ul,
ol,
li {
    list-style: none;
}

.notice .covid-19-confirm-page .btn-group,
.notice .exam-rules-page .btn-group,
.notice .wait-start-exam-page .btn-group {
    height: 80px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.notice .covid-19-confirm-page .btn-group .pop-sure,
.notice .exam-rules-page .btn-group .pop-sure,
.notice .wait-start-exam-page .btn-group .pop-sure {
    text-align: center;
    margin: 0 0 10px 0;
    position: absolute;
    top: -10px;
}

.pop-sure {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notice .covid-19-confirm-page .btn-group .btn-list,
.notice .exam-rules-page .btn-group .btn-list,
.notice .wait-start-exam-page .btn-group .btn-list {
    display: flex;
}

.btn {
    position: relative;
    display: inline-block;
    margin: 0 0.8rem !important;
    vertical-align: middle !important;
    padding: 5px 25px;
    color: #000;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.3s;
}

.default-btn,
.btn-primary {
    background: #447dff;
    color: #fff;
}

.cancel-btn,
.disabled-btn {
    background: #8c93ac;
    color: #fff;
}

.notice .instructions-page .operation-intro {
    width: 100%;
    height: 100%;
}

.notice .instructions-page .operation-intro .ct {
    width: 100%;
    height: 100%;
    display: block;
    background: #fff;
    position: relative;
    border-radius: 6px;
}

.notice .instructions-page .operation-intro .ct .info {
    /* width: 100%; */
    /* height: 93%; */
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 1.5rem 0 1.5rem;
    margin: 0 auto;
    position: absolute;
    top: 30px;
    left: 30px;
    right: 30px;
    bottom: 80px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area {
    width: 100%;
    padding-bottom: 1.5rem;
    height: 100%;
    position: relative;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .list-show {
    padding-right: 240px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt {
    width: 100%;
    height: 100%;
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
    box-shadow: inset 2px 2px 11px -1px #abb2db, inset -2px -2px 11px -1px #abb2db;
    padding: 30px;
    border-radius: 6px;
}

.notice .instructions-page .operation-intro .ct .info .list-show .rt {
    right: 0;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt {
    width: 240px;
    height: 100%;
    position: absolute;
    top: 0;
    padding: 1rem 0 1rem 60px;
}

.notice .instructions-page .operation-intro .ct .btn-list {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.notice .instructions-page .operation-intro .ct .info .list-show .rt .intro-lt-btn {
    left: -0.5px;
}

.notice .instructions-page .operation-intro .ct .info .top-info-area {
    width: 100%;
    height: 95px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page {
    margin-bottom: 50px;
}

.notice .instructions-page .page-h-tag {
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .top-info-area p {
    font-weight: bolder;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .title {
    color: #3279ff;
    font-size: 1.2rem;
    margin-bottom: 1.8rem;
    font-weight: bolder;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page>div {
    padding-right: 1rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .list-item ul li {
    margin-bottom: 2rem;
}


.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-lt-btn {
    transition: all 0.3s;
    width: 14px;
    height: 80px;
    display: block;
    background: #307aff;
    position: absolute;
    top: 50%;
    margin-top: -40px;
    opacity: 0.6;
    border-radius: 0 20px 20px 0;
    cursor: pointer;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list {
    width: 180px;
    height: 185px;
    position: relative;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-lt-btn:before {
    width: 18px;
    height: 18px;
    display: block;
    position: absolute;
    top: 50%;
    left: -2px;
    margin-top: -9px;
}

.notice .instructions-page .operation-intro .ct .info .list-show .rt .intro-lt-btn:before {
    content: "";
    background: url(../../../public/images/guide/right_iconfont.png);
    background-size: cover;
}

.notice .instructions-page .operation-intro .ct .info .list-hide .rt .intro-lt-btn:before {
    content: "";
    background: url(../../../public/images/guide/left_iconfont.png);
    background-size: cover;
}

.notice .instructions-page .operation-intro .ct .info .list-hide {
    padding-right: 0;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line {
    width: 4px;
    height: 100%;
    background: #ccceda;
    display: block;
    position: absolute;
    left: -2.1rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul {
    padding: 1rem 0;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line .top-point {
    top: -1rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line .line-point {
    width: 1rem;
    height: 1rem;
    background: #fff;
    border: 0.2rem solid #ccceda;
    border-radius: 2rem;
    position: absolute;
    left: 50%;
    margin-left: -0.5rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line .bottom-point {
    bottom: -1rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list .list-line .line-point {
    width: 1rem;
    height: 1rem;
    background: #fff;
    border: 0.2rem solid #ccceda;
    border-radius: 2rem;
    position: absolute;
    left: 50%;
    margin-left: -0.5rem;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li {
    height: 2.2rem;
    line-height: 2.2rem;
    position: relative;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li .select-tag {
    width: 1.5rem;
    height: 1rem;
    display: block;
    background: #307aff;
    clip-path: polygon(80% 0, 100% 50%, 80% 100%, 0 100%, 0% 50%, 0 0);
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li .tag {
    position: absolute;
    top: 50%;
    margin-top: -0.5rem;
    left: -2.45rem;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li div {
    display: inline-block;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li .select-tag+.text {
    color: #307aff !important;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .rt .intro-list ul li .text {
    cursor: pointer;
    font-weight: bolder;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .list-hide .rt {
    right: -288px;
    transition: all 0.3s;
}

.notice .instructions-page .operation-intro .ct .info .list-hide .rt .intro-lt-btn {
    left: -49.5px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .list-item ul li>.list-item-info {
    display: flex;
}

.notice .instructions-page .span-blue {
    color: #447dff;
    margin-right: 10px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .big-img {
    width: 80%;
    max-width: 1024px;
}

.notice .instructions-page .operation-intro .ct .info .intro-area .lt .page .page-img {
    display: block;
    margin: 2rem auto;
}

.notice .covid-19-confirm-page .wait-ct,
.notice .exam-rules-page .wait-ct,
.notice .wait-start-exam-page .wait-ct {
    box-shadow: none;
    border: none;
    display: flex;
    justify-content: center;
    background: #fff;
    align-items: center;
    flex-direction: column;
}

.notice .covid-19-confirm-page .start-exam .title,
.notice .exam-rules-page .start-exam .title,
.notice .wait-start-exam-page .start-exam .title {
    color: #36adb4;
}

.notice .covid-19-confirm-page .wait-ct .title,
.notice .exam-rules-page .wait-ct .title,
.notice .wait-start-exam-page .wait-ct .title {
    font-size: 58px;
    letter-spacing: 10px;
    margin-top: 58px;
}

.notice .covid-19-confirm-page .wait-ct .logo img,
.notice .exam-rules-page .wait-ct .logo img,
.notice .wait-start-exam-page .wait-ct .logo img {
    width: 100px;
    height: 100px;
}

.notice .covid-19-confirm-page .wait-ct .intro,
.notice .exam-rules-page .wait-ct .intro,
.notice .wait-start-exam-page .wait-ct .intro {
    font-size: 24px;
    color: #000;
    margin-top: 80px;
    text-align: center;
}

.notice .covid-19-confirm-page .wait-ct .intro p,
.notice .exam-rules-page .wait-ct .intro p,
.notice .wait-start-exam-page .wait-ct .intro p {
    margin-top: 10px;
}
</style>
